import { Box, Text, Spinner, Alert, AlertIcon, Link } from '@chakra-ui/react';
import { useNonce } from "../../context/NonceContext";
import { useAuth } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Home() {
  const { loading, error } = useNonce();
  const { isAuthenticated, user, setPromocode } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // Detectar código promocional en la URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const promocode = params.get('promocode');

    if (promocode) {
      // Llamar al backend para registrar el uso del código
      const usarCodigoPromocional = async () => {
        try {
          const baseURL = process.env.REACT_APP_API_BASE_URL;
          console.log(`[PROMOCODE] Procesando código: ${promocode}`);
          
          const response = await fetch(`${baseURL}/api/promo/usar/${promocode}`, {
            method: 'POST',
          });

          if (!response.ok) {
            throw new Error('Error al procesar el código promocional');
          }

          const data = await response.json();
          console.log('[PROMOCODE] Respuesta del servidor:', data);

          // Procesar según el resultado
          if (data.success && data.link) {
            console.log(`[PROMOCODE] ✅ Código válido - Redirigiendo a: ${data.link}`);
            console.log(`[PROMOCODE] Mensaje: ${data.mensaje}`);
            console.log(`[PROMOCODE] Hits actualizados: ${data.hits}`);

            // Guardar el código promocional en el contexto de autenticación
            setPromocode(promocode);

            // Redirigir al link después de un breve delay
            setTimeout(() => {
              window.location.href = data.link;
            }, 1000);
          } else {
            // Código no válido o sin redirección
            if (data.expirado) {
              console.warn(`[PROMOCODE] ⚠️ Código expirado: ${data.mensaje}`);
            } else if (data.sin_usos) {
              console.warn(`[PROMOCODE] ⚠️ Sin usos disponibles: ${data.mensaje}`);
            } else if (!data.activo) {
              console.warn(`[PROMOCODE] ⚠️ Código inactivo: ${data.mensaje}`);
            } else {
              console.log(`[PROMOCODE] ℹ️ Código registrado sin redirección: ${data.mensaje}`);
              // Guardar el código promocional aunque no tenga redirección
              setPromocode(promocode);
            }
            console.log(`[PROMOCODE] Hits registrados: ${data.hits}`);

            // Limpiar el código promocional del contexto si no es válido
            if (data.expirado || data.sin_usos || !data.activo) {
              console.log('[PROMOCODE] Limpiando código no válido del contexto');
              setPromocode(null);
            }

            // Limpiar el parámetro de la URL
            navigate('/', { replace: true });
          }
        } catch (err) {
          console.error('[PROMOCODE] ❌ Error al usar código promocional:', err);

          // Limpiar el código promocional del contexto en caso de error
          setPromocode(null);

          // Limpiar el parámetro de la URL
          navigate('/', { replace: true });
        }
      };

      usarCodigoPromocional();
    }
  }, [location.search, navigate, setPromocode]);

  if (loading) {
    return (
      <Box p={4} display="flex" justifyContent="center" alignItems="center" flexGrow={1} w="100%">
        <Spinner size="xl" />
        <Text ml={4}>{t('loading_nonce')}</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Alert status="error">
        <AlertIcon />
        {error}
      </Alert>
    );
  }

  return (
    <Box
      p={4}
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      w="100%"
      flexGrow={1}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      {isAuthenticated ? (
        <Text fontSize="lg">
          {t('bienvenido')}, {user.user_type} {user.email}!
          {user.user_type === 'cliente' && (
            <>
              &nbsp;
              <Link color="teal.500" href="/cliente/reserva" fontWeight="bold">
                {t('reserva_ya')}
              </Link>
            </>
          )}
        </Text>
      ) : (
        <>
          <Text fontSize="lg" mb={2}>
            {t('eres_cliente')}&nbsp;
            <Link color="teal.500" href="/registro-cliente" fontWeight="bold">
              {t('registro_usuario')}
            </Link>
          </Text>
          <Text fontSize="lg">
            {t('eres_conductor')}&nbsp;
            <Link color="teal.500" href="/registro-conductor" fontWeight="bold">
              {t('registro_conductor')}
            </Link>
          </Text>
        </>
      )}
    </Box>
  );
}

export default Home;